import { Stack } from '@mui/material';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { useIsDesktop } from 'Hooks';
import { useContext, useEffect, useState } from 'react';
import { AdvancedSearchPanel } from './AdvancedSearchPanel';
import { AdvancedSearchTitle } from './AdvancedSearchTitle';
import { SearchBySubject } from './SearchBySubject';
import { IReferralsState } from 'reducer/MedicalReferrals/ReferralReducer';
import { NewMedicalRequest } from '../NewMedicalRequest';
import { maxMedicalReferralsPerPage } from '..';

interface ISearchFilter {
  referrals: IReferralsState;
  dispatchReferrals: Function;
  providersList: string[];
  dateMinMaxRange: {
    min: Date;
    max: Date;
  };
  setTextSearchValue: (value: string) => void;
  loadAllReferrals: Function;
  referralsCount: number;
  advancedSearchOpen: boolean;
  setAdvancedSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SearchFilter = ({
  referrals,
  dispatchReferrals,
  providersList,
  dateMinMaxRange,
  setTextSearchValue,
  loadAllReferrals,
  referralsCount,
  advancedSearchOpen,
  setAdvancedSearchOpen,
}: ISearchFilter) => {
  const isDesktop = useIsDesktop();

  const { dispatchAdvancedSearch } = useContext(AdvancedSearchContext);

  useEffect(() => {
    dispatchAdvancedSearch({
      type: 'SEARCH_FIELDS_DATA_INITIALIZATION',
      payload: { value: { providersList, dateMinMaxRange, referrals } },
    });
  }, [dispatchAdvancedSearch, providersList, dateMinMaxRange]);

  useEffect(() => {
    if (advancedSearchOpen && referralsCount === maxMedicalReferralsPerPage)
      loadAllReferrals();
  }, [advancedSearchOpen]);

  return (
    <Stack gap={'40px'}>
      <NewMedicalRequest />
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent='space-between'
        flexWrap='wrap'
        gap={isDesktop ? '20px' : '32px'}
      >
        <SearchBySubject
          dispatchReferrals={dispatchReferrals}
          setTextSearchValue={setTextSearchValue}
          referrals={referrals}
        />
        {!advancedSearchOpen && (
          <AdvancedSearchTitle openAdvancedSearch={setAdvancedSearchOpen} />
        )}
        {advancedSearchOpen && (
          <AdvancedSearchPanel
            dispatchReferrals={dispatchReferrals}
            closeAdvancedSearch={setAdvancedSearchOpen}
          />
        )}
      </Stack>
    </Stack>
  );
};
